module.exports = __webpack_public_path__ + "iconfont.svg?5e7640f263d670c56e944057d150b8e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.svg?t=1534686008312
// module id = 129
// module chunks = 0